import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import { CountdownTimer } from 'src/components/Chicken/ui/countdown-timer/CountdownTimer'
import common from 'src/styles/common.module.scss'
import styles from './styles.module.scss'

export const TextHeaderEl = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    return (
        <div className={styles.wrapper_content}>
            <HighlightedText
                text="Μάντεψε πού είναι τα λεφτά."
                highlights={[
                    { word: 'Μάντεψε' },
                    { word: 'πού' },
                    { word: 'είναι' },
                    { word: 'τα' },
                    { word: 'λεφτά.' },
                ]}
                breakAfterWords={isDesktop ? [] : ['πού']}
                className={common.text_header}
            />
            <div className={styles.wrapper}>
                <span className={styles.text}>Έχεις τρεις προσπάθειες!</span>
                <CountdownTimer />
            </div>
        </div>
    )
}
